import { z } from "zod";
import { zCorpAdminStatus, zCorpCompanyStatus } from "./corpSession.common";
export const zCorpCompanyRefDom = z.object({
    id: z.string(),
    name: z.string(),
    status: zCorpCompanyStatus,
});
export const zCorpSessionDom = z.object({
    adminId: z.string(),
    email: z.string(),
    fullName: z.string(),
    status: zCorpAdminStatus,
    companies: z.array(zCorpCompanyRefDom),
});
